// Mini App Telegram: подпись initData добавляется к каждому запросу /api/, пока человек не вышел.
declare global {
  interface TelegramBackButton { show: () => void; hide: () => void; onClick: (fn: () => void) => void; offClick: (fn: () => void) => void }
  interface TelegramWebApp {
    initData?: string; ready?: () => void; expand?: () => void;
    colorScheme?: 'light' | 'dark';
    BackButton?: TelegramBackButton;
    setHeaderColor?: (color: string) => void; setBackgroundColor?: (color: string) => void;
  }
  interface Window { Telegram?: { WebApp?: TelegramWebApp } }
}

export function installTelegramAuth(): void {
  const app = window.Telegram?.WebApp;
  const initData = app?.initData;
  if (!initData) return;
  app.ready?.();
  app.expand?.();
  const authDate = new URLSearchParams(initData).get('auth_date');
  const key = 'sst-telegram-logout-auth-date';
  const loggedOut = !!authDate && localStorage.getItem(key) === authDate;
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input.toString() : input.url, window.location.href);
    if (!loggedOut && url.origin === window.location.origin && url.pathname.startsWith('/api/')) {
      const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
      headers.set('x-telegram-init-data', initData);
      init = { ...init, headers };
    }
    const response = await originalFetch(input, init);
    if (url.origin === window.location.origin && url.pathname === '/api/auth/logout' && authDate) localStorage.setItem(key, authDate);
    if (url.origin === window.location.origin && url.pathname === '/api/auth/telegram' && response.ok) localStorage.removeItem(key);
    return response;
  };
}
